const monitorReducerEnhancer =
  (createStore) => (reducer, initialState, enhancer) =>
    createStore(reducer, initialState, enhancer);
export default monitorReducerEnhancer;
